import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'store/pricingEvents';
import { DERactions } from 'store/DERs';

import AssetInfo from '../components/AssetInfo';

const mapStateToProps = (state) => ({
  ...state.DER,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...actions, ...DERactions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetInfo);
